import React from 'react'

import {
  getClassesFromMarginsProp,
  getClassesFromTitleStyleProp
} from '../../utils/utils'

import './title.styles.scss'

const Title = ({ content, quantity, margins, style, ...otherProps }) => {
  const {
    firstLine,
    singularFirstLine,
    pluralFirstLine,
    secondLine,
    singularSecondLine,
    pluralSecondLine
  } = content

  const marginClasses = getClassesFromMarginsProp(margins)
  const titleStyleClass = getClassesFromTitleStyleProp(style)

  const finalFirstLine =
    firstLine ||
    (quantity === 1 ? singularFirstLine : pluralFirstLine || firstLine)
  const finalSecondlLine =
    secondLine ||
    (quantity === 1 ? singularSecondLine : pluralSecondLine || secondLine)

  return (
    <h1 className={`title ${marginClasses} ${titleStyleClass}`}>
      {finalFirstLine}
      {typeof finalSecondlLine !== 'undefined' && (
        <span>{finalSecondlLine}</span>
      )}
    </h1>
  )
}

export default Title
